module.exports = "/assets/5578dd1cba125fac89ff721c276006fb.svg";